import { combineReducers } from 'redux';
import registerBussinesRules from './index';

const appReducer = combineReducers({
  registerBussinesRules: registerBussinesRules,
});

export default appReducer;
